function VkIconDark() {
  return (
    <svg
      className='hidden dark:block hover:scale-110 transition'
      width='32'
      height='20'
      viewBox='0 0 32 20'
      fill='none'
    >
      <path
        d='M18.7308 18.3308V13.2231C22.1615 13.7462 23.2462 16.4462 25.4308 18.3308H31C29.6076 15.2223 27.5301 12.4689 24.9231 10.2769C26.9231 7.52308 29.0462 4.93077 30.0846 1H25.0231C23.0385 4.00769 21.9923 7.53077 18.7308 9.85385V1H11.3846L13.1385 3.16923V10.9C10.2923 10.5692 8.36923 5.36154 6.28462 1H1C2.92308 6.89231 6.96923 19.8231 18.7308 18.3308Z'
        stroke='#fff'
        strokeWidth='1.984'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default VkIconDark;
